import { useEffect, useState } from 'react';

export const useDefaultDataInitialiser = (data) => {
  const [returnValue, setReturnValue] = useState(data || {});

  useEffect(() => {
    setReturnValue(data || {});
  }, [data]);

  return returnValue;
};
